<div class="container">
  <section class="guide-left"><flowaccount-guide-table></flowaccount-guide-table> </section>
  <section class="guide-right">
    <flowaccount-guide-breadcrumbs></flowaccount-guide-breadcrumbs>
    <flowaccount-guide-content></flowaccount-guide-content>
    <flowaccount-guide-footer></flowaccount-guide-footer>
  </section>
</div>

